// extracted by mini-css-extract-plugin
export var chartDark = "weatherWidget-module--chartDark--6mZOe";
export var chartLight = "weatherWidget-module--chartLight--17D7i";
export var dummy = "weatherWidget-module--dummy--diEIQ";
export var weatherWidgetDark = "weatherWidget-module--weatherWidgetDark--4dbtY";
export var weatherWidgetLight = "weatherWidget-module--weatherWidgetLight--gWbFm";